module.exports = require('./ManageAdvertising')